import { useEffect, useState } from "react";

const columns = [
  {
    title: "Id",
    dataIndex: "province_id",
    key: "province_id",
  },
  {
    title: "Province Name",
    dataIndex: "province_name",
    key: "province_name",
  },
  {
    title: "Alternative Name",
    dataIndex: "alternative_name",
    key: "alternative_name",
  },
  {
    title: "Region Name",
    dataIndex: ["regions", "region_name"],
    key: ["regions", "region_name"],
  },

  {
    title: "Date Created",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "Last Modified Date",
    dataIndex: "updated_at",
    key: "updated_at",
  },
];

export default function useGetProvinceColumns() {
  const [tableColumns, setColumns] = useState(columns);

  useEffect(() => {
    setColumns(setColumns);
  }, []);

  return tableColumns;
}
